<app-drop-down-section [title]="'admin.qa.field_errors_title' | transloco" [defaultOpen]="false"
    (openedChange)="onSectionToggle($event)">

    <div class="p-4 flex flex-col gap-4">
        <!-- Date Range + Supplier + Refresh -->
        <div class="flex flex-wrap items-end gap-3">
            <div class="min-w-[200px] max-w-[300px]">
                <app-custom-date-input labelText="{{ 'admin.from' | transloco }}" inputId="fieldErrorsFrom"
                    placeholder="{{ 'admin.from' | transloco }}" [(dateValue)]="fromDate" dateFormat="dd/mm/yy"
                    boxHeight="min-h-[48px] max-h-[48px]">
                </app-custom-date-input>
            </div>
            <div class="min-w-[200px] max-w-[300px]">
                <app-custom-date-input labelText="{{ 'admin.to' | transloco }}" inputId="fieldErrorsTo"
                    placeholder="{{ 'admin.to' | transloco }}" [(dateValue)]="toDate" dateFormat="dd/mm/yy"
                    boxHeight="min-h-[48px] max-h-[48px]">
                </app-custom-date-input>
            </div>
            <div class="w-[250px]">
                <app-custom-dropdown [options]="supplierDropdownOptions" [(selectedOption)]="selectedSupplierIndex"
                    (selectedOptionChange)="onSupplierChange()" label="{{ 'admin.qa.supplier' | transloco }}">
                </app-custom-dropdown>
            </div>
            <div class="w-[120px] h-[48px]">
                <app-custom-button buttonText="{{ 'admin.refresh' | transloco }}" [isDisabled]="loading"
                    backgroundColor="bg-primary-700" textColor="text-white" borderColor="border-primary-700"
                    hoverBackgroundColor="hover:bg-primary-800" (buttonClick)="loadFieldErrors()">
                </app-custom-button>
            </div>
        </div>

        <!-- Loading -->
        <div *ngIf="loading" class="flex justify-center py-8">
            <span class="loading loading-spinner loading-md text-primary-700"></span>
        </div>

        <!-- Bar Chart: Top 10 -->
        <div *ngIf="loaded && !loading && chartItems.length > 0">
            <div [style.height.px]="chartItems.length * 40 > 200 ? chartItems.length * 40 : 200">
                <app-qa-field-errors-chart [items]="chartItems"></app-qa-field-errors-chart>
            </div>
        </div>

        <!-- No data -->
        <div *ngIf="loaded && !loading && allErrors.length === 0" class="text-center text-neutral-400 py-4">
            {{ 'admin.qa.field_errors_no_data' | transloco }}
        </div>

        <!-- Detailed Breakdown -->
        <div *ngIf="loaded && !loading && allErrors.length > 0" class="flex flex-col gap-2">
            <button (click)="toggleDetailedBreakdown()"
                class="flex items-center gap-2 text-sm text-primary-700 hover:text-primary-900 cursor-pointer self-start">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 transition-transform"
                    [ngClass]="{ 'rotate-180': showDetailedBreakdown }" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <polyline points="6 9 12 15 18 9"></polyline>
                </svg>
                {{ 'admin.qa.field_errors_detailed' | transloco }}
            </button>

            <div *ngIf="showDetailedBreakdown" class="overflow-x-auto rounded-[8px] border border-neutral-200">
                <table class="table w-full table-sm">
                    <thead class="bg-neutral-100 text-neutral-600 uppercase">
                        <tr>
                            <th class="px-3 py-2 font-normal text-xs">#</th>
                            <th class="px-3 py-2 font-normal text-xs">{{ 'admin.qa.field' | transloco }}</th>
                            <th class="px-3 py-2 font-normal text-xs">{{ 'admin.qa.top_supplier' | transloco }}</th>
                            <th class="px-3 py-2 font-normal text-xs">{{ 'admin.qa.wrong_value' | transloco }}</th>
                            <th class="px-3 py-2 font-normal text-xs">{{ 'admin.qa.not_extracted' | transloco }}</th>
                            <th class="px-3 py-2 font-normal text-xs">{{ 'admin.qa.total_fields' | transloco }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let err of allErrors; let i = index" class="hover:bg-neutral-50">
                            <td class="px-3 py-2 text-sm text-neutral-400">{{ i + 1 }}</td>
                            <td class="px-3 py-2 text-sm font-medium">{{ formatFieldName(err.field_name) }}</td>
                            <td class="px-3 py-2 text-sm">{{ err.top_supplier ? formatSupplierName(err.top_supplier) :
                                '-' }}</td>
                            <td class="px-3 py-2 text-sm text-error-500">{{ err.wrong_value }}</td>
                            <td class="px-3 py-2 text-sm text-warning-500">{{ err.not_extracted }}</td>
                            <td class="px-3 py-2 text-sm font-medium">{{ err.total }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</app-drop-down-section>